/* eslint-disable react/prop-types */
import React, { useEffect, useState, useCallback } from 'react';
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  AutoComplete,
} from 'antd';
import { OnFetchShipmentSno } from '../../redux/ShipmentDetails/saga';
import { OnAddorUpdateShipmentsDashboard } from '../../redux/ShipmentDashboardDetails/saga';
import { getPopupContainerBody } from './shipmentFieldOptions';

const { Option } = Select;

const AddNewShipments = (props) => {
  const {
    showAddModel,
    setShowAddModel,
    editRecord,
    isEdit,
    setIsEdit,
    setEditRecord,
    OnfetchData,
    selectedProject,
    adminShipmentTypesList,
  } = props;

  const [shipmentType, setShipmentType] = useState('');
  const [ShipmentNumber, setShipmentNumber] = useState('');
  const [addLoading, setAddLoading] = useState(false);
  const [equipTypeForm] = Form.useForm();

  const [serialNoList, setSerialNoList] = useState([]);
  const [serialNo, setSerialNo] = useState('');
  const [shipmentTyCategory, setShipmentTypeCategory] = useState('');
  const [serialNoLoading, setSerialNoLoading] = useState(false);

  const OnfetchSerialNumberData = useCallback(async (selectedShipmentType) => {
    setSerialNoLoading(true);
    const obj = { id: selectedShipmentType.id };
    setShipmentType(selectedShipmentType.name);
    const res = await OnFetchShipmentSno(obj, 'false');
    const list = res?.shipmentType?.shipments && res.shipmentType.shipments.length > 0
      ? res.shipmentType.shipments
      : [];
    setSerialNoList(list);
    setSerialNoLoading(false);
    return list;
  }, []);

  useEffect(() => {
    if (!isEdit || !editRecord || !adminShipmentTypesList?.length) return;

    const run = async () => {
      const shipmentArr = adminShipmentTypesList.filter(
        (item) => item.name === editRecord.shipmentTypeName
      );
      if (!shipmentArr.length) return;

      setShipmentTypeCategory(shipmentArr[0]);
      setShipmentType(shipmentArr[0].name);
      const list = await OnfetchSerialNumberData(shipmentArr[0]);
      const num = editRecord.shipmentNumber;
      setShipmentNumber(num || '');
      const match = list.find((item) => item.shipmentNumber === num);
      setSerialNo(match || (num ? { shipmentNumber: num } : ''));
    };

    run();
  }, [isEdit, editRecord, adminShipmentTypesList, OnfetchSerialNumberData]);

  const onChangeShipmentType = async (value) => {
    setSerialNo('');
    setShipmentNumber('');
    if (value) {
      const shipmentArr = adminShipmentTypesList?.filter((item) => item.name === value) || [];
      if (shipmentArr.length > 0) {
        setShipmentTypeCategory(shipmentArr[0]);
        await OnfetchSerialNumberData(shipmentArr[0]);
      } else {
        setShipmentTypeCategory('');
        setShipmentType('');
        setSerialNoList([]);
      }
    } else {
      setShipmentTypeCategory('');
      setShipmentType('');
      setSerialNoList([]);
      setShipmentNumber('');
    }
  };

  const onShipmentNumberChange = (value) => {
    const v = typeof value === 'string' ? value.trim() : '';
    setShipmentNumber(v);
    if (!v) {
      setSerialNo('');
      return;
    }
    const match = serialNoList.find((item) => item.shipmentNumber === v);
    setSerialNo(match || { shipmentNumber: v });
  };

  const autoCompleteOptions = serialNoList.map((item) => ({
    value: item.shipmentNumber,
    label: item.shipmentNumber,
  }));

  const handleOk = async () => {
    if (shipmentTyCategory === '') {
      notification.warning({
        message: 'Please select shipment type to proceed!',
      });
      return;
    }
    const num = (ShipmentNumber || '').trim();
    if (!num) {
      notification.warning({
        message: 'Please enter or select a shipment number to proceed!',
      });
      return;
    }
    const data = {
      shipmentTypeId: shipmentTyCategory.id,
      projectId: selectedProject.id,
      status: 1,
    };

    const matched = serialNoList.find((item) => item.shipmentNumber === num);
    if (matched?.id) {
      data.shipmentId = matched.id;
    } else if (serialNo?.id) {
      data.shipmentId = serialNo.id;
    } else {
      data.shipmentNumber = num;
    }

    let payload = data;
    if (isEdit) {
      payload = {
        id: editRecord.pihShipmentId,
        data,
      };
    }

    setAddLoading(true);
    const res = await OnAddorUpdateShipmentsDashboard(payload, isEdit);

    if (res) await OnfetchData();
    else {
      notification.warning({
        message: `${shipmentType} and ${ShipmentNumber} could not be saved. It may already exist.`,
      });
    }

    setAddLoading(false);
    resetForm();
    setShowAddModel(false);
  };

  const resetForm = () => {
    setShipmentType('');
    setShipmentNumber('');
    setSerialNo('');
    setSerialNoList([]);
    setShipmentTypeCategory('');
    setIsEdit(false);
    if (setEditRecord) setEditRecord('');
  };

  const handleCancel = () => {
    setShowAddModel(false);
    resetForm();
  };

  return (
    <div>
      <Modal
        className="pipeline-modal shipment-add-modal"
        title={isEdit ? 'Update Shipment Data' : 'Add New Shipment Data'}
        centered
        visible={showAddModel}
        width={640}
        destroyOnClose
        bodyStyle={{
          maxHeight: 'calc(100vh - 220px)',
          overflowY: 'auto',
          padding: '16px 24px 8px',
        }}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancel}
          >
            {'Cancel'}
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleOk}
            loading={addLoading}
          >
            {isEdit ? 'Update' : 'Add'}
          </Button>,
        ]}
      >
        <Form
          form={equipTypeForm}
          name="basic"
          layout="vertical"
          autoComplete="off"
          getContainer={false}
        >
          <Row gutter={[16, 8]}>
            <Col
              xs={24}
              sm={24}
              md={12}
            >
              <Form.Item
                label="Shipment Type"
                name="Shipment Type"
                required
              >
                <Select
                  className="client-select"
                  placeholder="Select  Shipment type"
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  onChange={onChangeShipmentType}
                  value={shipmentType === '' ? null : shipmentType}
                  getPopupContainer={getPopupContainerBody}
                >
                  {adminShipmentTypesList &&
                    adminShipmentTypesList.map((item, i) => (
                      <Option
                        key={i}
                        value={item && item.name}
                      >
                        {item && item.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
            >
              <Form.Item
                label="Shipment Number"
                name="shipmentNumber"
                required
              >
                <AutoComplete
                  className="client-select"
                  style={{ width: '100%' }}
                  options={autoCompleteOptions}
                  placeholder={
                    serialNoLoading ? 'Loading…' : 'Shipment number'
                  }
                  disabled={shipmentType === ''}
                  value={ShipmentNumber}
                  onChange={onShipmentNumberChange}
                  getPopupContainer={getPopupContainerBody}
                  filterOption={(inputValue, option) =>
                    (option?.value || '')
                      .toString()
                      .toLowerCase()
                      .includes((inputValue || '').toLowerCase())
                  }
                >
                  <Input />
                </AutoComplete>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default AddNewShipments;
